import arrayMove from "array-move";
import _ from "lodash";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import {
  fuelPriceOptions,
  isSingleOperationTaken,
  termsCoEfficientTable,
  vesselVesselPortOperationHeader
} from "../../constants";
import * as actions from "../../containers/User/Calculator/actions";
import { toastError } from "../../utils";
import CustomShowModal from "../Common/CustomShowModal";
import AddOperationsModal from "./AddOperationsModal";
import AddPortsModal from "./AddPortsModal";
import BunkerSupply from "./BunkerSupply";
import MarginAllowancesTable from "./MarginAllowancesTable";
import PortDistanceModal from "./PortDistanceModal";
import VesselVesselDraggableList from "./VesselVesselDraggableList";

function VesselVesselPortOperations(props) {
  const {
    disableEdit = false,
    sendCalculationRequest = () => { },
    calculatorData = [],
    setCalculatorData = () => { },
    onChangePortOperations = () => { },
    marginModal = false,
    setMarginModal = () => { },
    syncBunker = true,
    setSyncBunker = () => { },
    onAddOperations = () => { },
    onDeleteOperations = () => { },
    selectedVessels = {},
    supplyModal = false,
    setSupplyModal = () => { },
    onChangeSyncBunker = () => { },
    onFetchPortOperationDistance = () => { },
    openAddOperation = false,
    openAddOperationIndex,
    setOpenAddOperation = () => { },
    setOpenAddOperationindex = () => { },
    onChangeSelectedVessel = () => { },
    isOverride = false,
    setIsOverride = () => { },
    onChangePortCanalInQueryState = () => { },
    onClickCalculateAndSave = () => { sendCalculationRequest({ ...calculatorData, autoSave: false }) },
  } = props;
  const { portOperation = [], clientQuery = {} } = calculatorData || {};
  const { cargoTransactionMode = false } = clientQuery;

  const [termsModal, setTermsModal] = useState(false);
  const [distanceModal, setDistanceModal] = useState(false);
  //
  const [selectedOperation, setSelectedOperation] = useState({});
  // const [cargoTxOverride, setCargoTxOverride] = useState(false)
  const [addPortModal, setAddPortModal] = useState(false);
  const [portLoading, setPortLoading] = useState(false);
  const [portOptions, setPortOptions] = useState([]);
  const emptyAddOperation = {
    operation: "Bunkering",
    port: "",
    portExp: 0,
    extraDays: 0,
    lat: 0,
    lng: 0
  };
  const [initialAddOperation, setInitialAddOperation] = useState(emptyAddOperation);

  const delayPortsSearch = useCallback(
    _.debounce(
      (selectedOperation, search, isInitialData = false) =>
        onSearchPortList(selectedOperation, search, isInitialData),
      500
    ),
    []
  );

  const containerRef = useRef(null);

  const handleSortStart = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  };

  const handleSortEnd = (sortParams) => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
    onSortEnd(sortParams);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (
      portOperation[oldIndex].operation === "Commence" ||
      portOperation[newIndex].operation === "Commence"
    )
      return;

    if (portOperation[oldIndex].operation === "Delivery-out") {
      const redeliveryInIndex = portOperation?.findIndex(item => item.operation === "Redelivery-in");
      // findIndex is -1 when there is no Redelivery-in yet; that must not block the move
      if (redeliveryInIndex !== -1 && redeliveryInIndex <= newIndex) {
        toastError("Delivery-out cannot be moved below Redelivery-in");
        return;
      }
    } else if (portOperation[oldIndex].operation === "Redelivery-in") {
      const deliveryOutIndex = portOperation?.findIndex(item => item.operation === "Delivery-out");
      if (deliveryOutIndex !== -1 && newIndex <= deliveryOutIndex) {
        console.log("Invalid move: 'Redelivery-in' cannot be moved above 'Delivery-out'");
        return;
      }
    }

    let newCombinedOperation = arrayMove(portOperation, oldIndex, newIndex);

    // Block only when a Loading port ends up after the LAST Discharging port.
    // Interleaved patterns (Loading between Discharge ports) are valid.
    let lastDischargingIndex = -1;
    let lastLoadingIndex = -1;
    for (let i = 0; i < newCombinedOperation.length; i++) {
      if (newCombinedOperation[i].operation === "Discharging") {
        lastDischargingIndex = i;
      }
      if (newCombinedOperation[i].operation === "Loading") {
        lastLoadingIndex = i;
      }
    }
    if (
      lastDischargingIndex !== -1 &&
      lastLoadingIndex !== -1 &&
      lastLoadingIndex > lastDischargingIndex
    ) {
      toastError("Loading operations cannot be moved below Discharging operations");
      return;
    }

    const updatedData = {
      ...calculatorData,
      portOperation: [...newCombinedOperation].map((item, index) => ({
        ...item,
        index,
      })),
    };
    setCalculatorData(updatedData);
    onFetchPortOperationDistance(false, updatedData, {}, true);
  };

  const onClickHeaderModal = (headerName) => {
    if (headerName === "Terms") {
      setTermsModal(true);
    } else if (headerName === "Supply") {
      setSupplyModal(true);
    } else if (headerName === "Dist Normal" || headerName === "Dist ECA") {
      setDistanceModal(true);
    } else {
      return;
    }
  };

  const onChangeBunkerScrubber = (index, e) => {
    const { name = "", value = "" } = e.target;
    console.log('==ASDFASFD===>', index, name, value)

    let newPortOperation = [...portOperation];
    newPortOperation[index].cargoDetails[name] = Number(value);
    setCalculatorData({ ...calculatorData, portOperation: newPortOperation });
  };

  const onClickSinglePort = (operation, index) => {
    if (disableEdit) return toastError("Changing ports is disabled in this view.");
    setSelectedOperation({ ...operation, _portIndex: index });
    setAddPortModal(true);
  };

  const onSearchPortList = (
    selectedOperation,
    value,
    isInitialData = false
  ) => {
    if (isInitialData) {
      setInitialAddOperation({ ...selectedOperation, port: value });
    } else {
      setSelectedOperation({ ...selectedOperation, port: value });
    }
    if (value?.length > 2) {
      setPortLoading(true);
      actions
        .portsByChar(value)
        .then((res) => {
          setPortLoading(false);
          setPortOptions(
            (Array.isArray(res.data.list) &&
              res.data.list.map((item) => ({
                label: `${item.name} ${item.country ? "(" + item.country + ")" : ""
                  }`,
                value: item.name,
                lat: item?.lat,
                lng: item?.lng
              }))) ||
            []
          );
        })
        .catch((err) => {
          setPortLoading(false);
        });
    }
  };

  const onSelectPortsOfOperation = (selectedPort) => {
    let portIndex = selectedOperation._portIndex;
    if (portIndex === undefined) {
      portIndex = portOperation.findIndex(
        (item) => item._id === selectedOperation._id
      );
    }
    if (portIndex > -1) {
      const updatedOperation = [...portOperation];
      updatedOperation[portIndex].port = selectedPort.value;
      updatedOperation[portIndex].lat = selectedPort.lat;
      updatedOperation[portIndex].lng = selectedPort.lng;

      setSelectedOperation({ ...selectedOperation, port: selectedPort.value });
      setCalculatorData({
        ...calculatorData,
        portOperation: updatedOperation,
      });
    }
  };

  const onClickCalculateDistance = () => {
    onFetchPortOperationDistance(false, null, {}, true);
    setAddPortModal(false);
  };

  const onAddOperationByModal = () => {
    const {
      operation = "",
      port = "",
      portExp = 0,
      portStay = 0,
    } = initialAddOperation;
    if (!operation || !port) {
      return toastError("Port is required");
    }
    if (isSingleOperationTaken(portOperation, operation)) {
      return toastError(`Only one ${operation} operation is allowed per contract.`);
    }
    onAddOperations(initialAddOperation, openAddOperationIndex);
    setOpenAddOperation(false);
    // fresh form for the next port
    setInitialAddOperation(emptyAddOperation);
    setPortOptions([]);
    setPortLoading(false);
  };

  const dischargedPortIndexes = useMemo(() => {
    let indexes = [];
    for (let i = 0; i < portOperation.length; i++) {
      if (portOperation[i].operation === "Discharging") {
        indexes.push(i);
      }
    }
    indexes.splice(indexes.length - 1, 1);
    return indexes;
  }, [portOperation]);

  const onSetCargoTxOverride = (checked) => {
    // setCargoTxOverride(checked)
    const updatedPortOperation = [...portOperation];
    for (let i = 0; i < dischargedPortIndexes.length; i++) {
      updatedPortOperation[dischargedPortIndexes[i]].cargoTxOverriddenValue = 0;
      updatedPortOperation[dischargedPortIndexes[i]].cargoTx = 0;
    }
    setCalculatorData({
      ...calculatorData,
      clientQuery: { ...clientQuery, cargoTransactionMode: checked },
      portOperation: updatedPortOperation,
    });
  };

  const termsToDisplay = termsCoEfficientTable.filter(
    (item) => item.value !== 0
  );
  let newPortOperationHeader = [...vesselVesselPortOperationHeader];


  const getColumnStyle = (item) => ({
    minWidth: item.width,
    width: item.width,
    flex: `${item.width || 40} 1 ${item.width || 40}px`,
    paddingLeft: item?.paddingLeft,
  });

  let showModal = ["Dist Normal", "Dist ECA", "Terms"];
  if (disableEdit) showModal = showModal.filter((item) => item !== "Supply");

  return (
    <div
      ref={containerRef}
      style={{ overflowX: "auto", overflowY: "hidden" }}
      className="operation-background scroll-thin"
      onScroll={(e) => {
        if (e.currentTarget.scrollTop !== 0) {
          e.currentTarget.scrollTop = 0;
        }
      }}
    >
      <div className="port-operation-buttons">
        {/* <button
          onClick={() => setOpenAddOperation(true)}
          className="text-center py-1 bg-neutrals9 hover:bg-neutrals7 px-3 border border-neutrals6 text-neutrals4 rounded-md text-sm flex items-center gap-1 mb-2"
        >
          + Add Operations
        </button> */}
      </div>
      <div className="port-operation-header">
        {newPortOperationHeader.map((item, index) => {
          const { fuelType = "" } = clientQuery || {}
          let selectedFuelType = fuelPriceOptions.find(item => item.value === fuelType)
          if (selectedFuelType) selectedFuelType = selectedFuelType.label
          else selectedFuelType = 'Type-1'
          const currentType = fuelType.replace("TYPE", "")
          return (
            <div key={index} style={getColumnStyle(item)}>
              <span
                style={{
                  color: "#000000",
                  textDecoration: "none",
                  display: item?.display || "flex",
                  flexDirection: item?.justifyContent ? "" : "column",
                  justifyContent: item?.justifyContent || "",
                  borderRight: item?.borderRight || "none",
                  borderLeft: item?.borderLeft || "none",
                }}
              >
                {item.header}
                {item?.dynamicHeader ? (selectedFuelType) : ""}
              </span>
            </div>
          );
        })}


      </div>
      <div className="port-operation-header" style={{ borderRadius: "0px" }}>
        {newPortOperationHeader.map((item, index) => {
          const isModalField = showModal.includes(item.label);
          // console.log(showModal, "showModal")

          if (disableEdit && item.label === "Add Opr..") {
            return
          }
          return (
            <div key={index} style={getColumnStyle(item)}>
              <span
                style={{
                  cursor: isModalField ? "pointer" : "default",
                  color: "#000000",
                  textDecoration: isModalField ? "underline" : "none",
                }}
                onClick={() => {
                  if (isModalField) {
                    onClickHeaderModal(item.label);
                  }
                }}
              >
                {item.label}
                {item.label === "Cargo Tx" ? (
                  <input
                    type="checkbox"
                    checked={cargoTransactionMode}
                    onChange={(e) => onSetCargoTxOverride(e.target.checked)}
                  />
                ) : null}
              </span>
            </div>
          );
        })}
      </div>
      {portOperation.length ? (
        <VesselVesselDraggableList
          useDragHandle
          lockAxis="y"
          lockToContainerEdges={true}
          autoScroll={false}
          helperClass="SortableHelper"
          onSortStart={handleSortStart}
          onSortEnd={handleSortEnd}
          onChangePortOperations={onChangePortOperations}
          combinedOperation={portOperation}
          onDeleteOperations={onDeleteOperations}
          onClickSinglePort={onClickSinglePort}
          cargoTxOverride={cargoTransactionMode}
          dischargedPortIndexes={dischargedPortIndexes}
          setOpenAddOperation={setOpenAddOperation}
          setOpenAddOperationindex={setOpenAddOperationindex}
          disableEdit={disableEdit}
          selectedVessels={selectedVessels}
          clientQuery={clientQuery}
          onChangeBunkerScrubber={onChangeBunkerScrubber}
        />
      ) : (
        <div className="no-port-found-div">
          <p>No port operations found.</p>
        </div>
      )}

      <CustomShowModal
        open={termsModal}
        handleClose={() => setTermsModal(false)}
        maxWidth="none"
        title="Terms Co-efficient Table"
      >
        <div className="w-[260px] border border-slate-300 rounded-none overflow-hidden my-0.5">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-[#f0f2f5] border-b border-slate-300">
                <th className="px-2.5 py-1 text-[11px] font-medium text-slate-700 border-r border-slate-300">
                  Terms (Contract Type)
                </th>
                <th className="px-2.5 py-1 text-[11px] font-medium text-slate-700 text-right">
                  Multiplier (Factor)
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white">
              {termsToDisplay.map((term, index) => (
                <tr key={index} className="hover:bg-slate-50 transition-colors">
                  <td className="px-2.5 py-0.5 text-[11px] font-medium text-slate-800 border-r border-slate-200">
                    {term.label}
                  </td>
                  <td className="px-2.5 py-0.5 text-[11px] font-medium text-slate-800 text-right">
                    {term.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CustomShowModal>

      <CustomShowModal
        open={supplyModal}
        handleClose={() => setSupplyModal(false)}
        maxWidth="lg"
        title="Bunker Supply Table"
      >
        <BunkerSupply
          portOperation={portOperation}
          syncBunker={syncBunker}
          setSyncBunker={setSyncBunker}
          clientQuery={clientQuery}
          onChangeBunkerScrubber={onChangeBunkerScrubber}
          selectedVessels={selectedVessels}
          onChangeSyncBunker={onChangeSyncBunker}
          onChangeSelectedVessel={onChangeSelectedVessel}
          onChangePortOperations={onChangePortOperations}
          isOverride={isOverride}
          setIsOverride={setIsOverride}
        />
      </CustomShowModal>

      <CustomShowModal
        open={marginModal}
        handleClose={() => setMarginModal(false)}
        maxWidth="sm"
        title="Margin Allowances Table"
      >
        <MarginAllowancesTable
          calculatorData={calculatorData}
          setCalculatorData={setCalculatorData}
        />
      </CustomShowModal>

      <CustomShowModal
        open={distanceModal}
        handleClose={() => setDistanceModal(false)}
        maxWidth="lg"
        title="Port Distance"
      >
        <PortDistanceModal
          calculatorData={calculatorData}
          setCalculatorData={setCalculatorData}
          onFetchPortOperationDistance={onFetchPortOperationDistance}
          onChangePortCanalInQueryState={onChangePortCanalInQueryState}
          onClose={() => setDistanceModal(false)}
          onClickCalculateAndSave={onClickCalculateAndSave}
        />
      </CustomShowModal>

      <CustomShowModal
        open={addPortModal}
        handleClose={() => setAddPortModal(false)}
        maxWidth="xs"
        title={`Change ${selectedOperation.operation} Port`}
      >
        <AddPortsModal
          selectedOperation={selectedOperation}
          delayPortsSearch={delayPortsSearch}
          portOptions={portOptions}
          portLoading={portLoading}
          onClickCalculateDistance={onClickCalculateDistance}
          onSelectPortsOfOperation={onSelectPortsOfOperation}
        />
      </CustomShowModal>

      <CustomShowModal
        open={openAddOperation}
        handleClose={() => setOpenAddOperation(false)}
        maxWidth="xs"
        title={`Add Operation`}
      >
        <AddOperationsModal
          selectedOperation={selectedOperation}
          delayPortsSearch={delayPortsSearch}
          portOptions={portOptions}
          portLoading={portLoading}
          initialAddOperation={initialAddOperation}
          setInitialAddOperation={setInitialAddOperation}
          onClickCalculateDistance={onClickCalculateDistance}
          onSelectPortsOfOperation={onSelectPortsOfOperation}
          onAddOperationByModal={onAddOperationByModal}
          vesselVesselOperationList={portOperation}
        />
      </CustomShowModal>
    </div>
  );
}

export default memo(VesselVesselPortOperations);
